<template>
  <div>
    <img v-if="url && dataUrl" :src="dataUrl" :style="imageStyle" alt="QR code" />
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, watch, computed } from 'vue'
import QRCode from 'qrcode'

const props = withDefaults(
  defineProps<{
    url: string | null
    size?: number
  }>(),
  {
    size: 300,
  },
)

const dataUrl = ref<string>('')
const imageStyle = computed(() => ({
  width: `${props.size}px`,
  height: `${props.size}px`,
}))

async function generateQRCode() {
  if (!props.url) {
    dataUrl.value = ''
    return
  }

  try {
    dataUrl.value = await QRCode.toDataURL(props.url, {
      width: props.size,
      margin: 2,
    })
  } catch (error) {
    console.error('Error generating QR code:', error)
    dataUrl.value = ''
  }
}

onMounted(() => {
  generateQRCode()
})

watch(
  () => [props.url, props.size],
  () => {
    generateQRCode()
  },
)
</script>
